/**
 * Shared webdesigned constants and helpers.
 * Use these instead of duplicating getStayName, seasonStyle, or header height.
 */

/** Fallback header clearance until `--wd-header-offset` is measured (stacked mobile nav). */
export const WEBDESIGNED_HEADER_HEIGHT_PX = 116;

export function getStayName(name: string): string {
  const nameMap: Record<string, string> = {
    'Le Renard': 'chalets.leRenard',
    'Le Lynx': 'chalets.leLynx',
    'La Perdrix': 'chalets.laPerdrix',
    'Le Loup': 'chalets.leLoup',
    'Le Huard': 'chalets.leHuard',
    'La Bécasse': 'chalets.laBecasse',
    "L'Original": 'chalets.lOriginal',
    'Yourte': 'stays.yourtes',
  };
  return nameMap[name] || name;
}

export const seasonStyle: Record<string, { bg: string; text: string; label: string }> = {
  été: { bg: '#d1fae5', text: '#065f46', label: 'Été' },
  hiver: { bg: '#dbeafe', text: '#1e3a8a', label: 'Hiver' },
  automne: { bg: '#ffedd5', text: '#9a3412', label: 'Automne' },
  toute_année: { bg: '#ede9fe', text: '#5b21b6', label: 'Toute Année' },
};
